import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignUpComponent } from '../authModule/signup/signup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LoginComponent } from '../authModule/login/login.component';
import { StoreModule } from '@ngrx/store';
import { AccountVerificationComponent } from './account-verification/account-verification.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { fromLtiActivization } from './from-lti-activization/from-lti-activization.component';
import { authReducer } from './state/authentication.reducer';
import { TermsAndConditionsComponent } from './signup/terms-and-conditions/terms-and-conditions.component';
import { MatDialogModule } from '@angular/material/dialog';
import {EmailConfirmationSendComponent} from './signup/email-confirmation-send/email-confirmation-send.component'

import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { LtiLoginComponent } from './lti-login/lti-login.component';
import { AuthCallbackComponent } from '../auth-callback/auth-callback.component';
import { SharedModule } from '../sharedModule/shared.module';

import { PrecheckExternalComponent } from '../student-components/precheck-external/precheck-external.component';
import { PrecheckExternalModule } from '../student-components/precheck-external/precheck-external.module';
import { PrecheckTestComponent } from '../student-components/precheck-external/precheck-test-screen/precheck-test.component';
import { MfaVerificationComponent } from './mfa-verification/mfa-verification.component';
import { EffectsModule } from '@ngrx/effects';
import { AuthenticationEffects } from './state/authentication.effects';

const authRoutes: Routes = [
   { path: '', pathMatch: 'full', redirectTo: 'login' },
   { path: 'login', component: LoginComponent },
   { path: 'login/:institutionName/:role', component: LoginComponent },
   { path: 'mfa-verification', component: MfaVerificationComponent },
   { path: 'auth-callback', component: AuthCallbackComponent },
   // { path: 'sign-up', component: SignUpComponent },
   // { path: 'sign-up/:profile', component: SignUpComponent },
   { path: 'forgot-password', component: ForgotPasswordComponent },
   { path: 'activate-account', component: fromLtiActivization },
   { path: 'account-verify/:token', component: AccountVerificationComponent },
   { path: 'email-confirmation/:email', component: EmailConfirmationSendComponent },
   {
      path: 'account-verify/:token/:provider',
      component: AccountVerificationComponent,
   },
   {
      path: 'lti/:token',
      component: LtiLoginComponent,
   },
   { path: 'precheck-external', component: PrecheckExternalComponent },
   { path: 'precheck-external/session/:sessionId', component: PrecheckExternalComponent },
   { path: 'precheck-test', component: PrecheckTestComponent },
];

@NgModule({
   declarations: [
      SignUpComponent,
      LoginComponent,
      ForgotPasswordComponent,
      AccountVerificationComponent,
      TermsAndConditionsComponent,
      fromLtiActivization,
      MfaVerificationComponent
   ],
   imports: [
      CommonModule,
      MatCheckboxModule,
      MatInputModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatDialogModule,
      TranslateModule,
      RecaptchaModule,
      RecaptchaFormsModule,
      RouterModule.forChild(authRoutes),
      // we are using for Feature now beacause this is a featuer and to setup a feature we use a key and also the reducer file
      StoreModule.forFeature('user', authReducer),
      SharedModule,
      PrecheckExternalModule,
      EffectsModule.forFeature([AuthenticationEffects])
   ],
   exports: [TranslateModule,],
})
export class AuthmoduleModule {}
